import { render, staticRenderFns } from "./Github.vue?vue&type=template&id=6dda82f2&scoped=true&"
import script from "./Github.vue?vue&type=script&lang=js&"
export * from "./Github.vue?vue&type=script&lang=js&"
import style0 from "./Github.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Github.vue?vue&type=style&index=1&id=6dda82f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda82f2",
  null
  
)

export default component.exports